import React, { FC } from 'react';
import AUSubNavComponent from '@aarhus-university/au-lib-react-components/src/components/AUSubNavComponent';
import { useLangContext, useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useEnrolmentContext } from '../../lib/context';
import { useGetExamResultsQuery } from '../../services/api';
import { useTranslationsContext } from '../../lib/translation';
import NotificationItemComponent from './NotificationItemComponent';

const NotificationsComponent: FC = () => {
  const lang = useLangContext();
  const user = useUserContext();
  const translations = useTranslationsContext();
  const enrolments = useEnrolmentContext();
  const { data } = useGetExamResultsQuery({
    auId: user?.auId || 0,
    relations: enrolments?.educations.map((e) => e.relationId) || [],
    lang,
  }, {
    skip: !enrolments || enrolments?.educations.length === 0,
  });

  const renderNotifications = (data || []).map((n) => (
    <NotificationItemComponent
      key={n.id}
      notification={n}
    />
  ));

  return (
    <AUSubNavComponent
      className={`nav__item nav__item--icon nav__item--icon--hide-label${(data || []).filter((x) => !x.read).length > 0 ? ' nav__item--attention' : ''}`}
      dataIcon=""
      text={translations.generics.sub_nav.notifications.header}
      ariaLabel={translations.generics.sub_nav.notifications.header}
      id="notifications-menu-toggle"
    >
      <div className="sub-nav__content theme--normal" aria-labelledby="notifications-menu-toggle">
        {
          (data || []).length === 0 && (
            <div className="empty-state">
              <div className="empty-state__text">
                {translations.generics.sub_nav.notifications.empty}
              </div>
            </div>
          )
        }
        {
          (data || []).length > 0 && (
            <ul className="ul--no-bullets sub-nav__notifications">
              {renderNotifications}
            </ul>
          )
        }
      </div>
    </AUSubNavComponent>
  );
};

NotificationsComponent.displayName = 'NotificationsComponent';
export default NotificationsComponent;
